import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
// import HeaderTop from '../../../components/HeaderTop'
import HeroSlider from '../../../components/HeroSlider'
// import Service from '../../../components/Service';
import About from '../../../components/About'
// import ServiceArea from '../../../components/ServiceArea';
import Portfolio from '../../../components/Portfolio'
// import Testmonial from '../../../components/Testmonial';
// // import ContactArea from '../../../components/ContactArea';
import TeamMember from '../../../components/TeamMember'
import CounterArea from '../../../components/CounterArea'
import BlogArea from '../../../components/BlogArea'
// import NewsLetter from '../../../components/Newsletter';
import FooterArea from '../../../components/FooterArea'
// images
import about from '../../../images/about/2.jpg'


// images
import portfolio1 from '../../../images/studies/1.jpg'
import portfolio2 from '../../../images/studies/2.jpg'
import portfolio3 from '../../../images/studies/3.jpg'
import portfolio4 from '../../../images/studies/4.jpg'
import portfolio5 from '../../../images/studies/5.jpg'

const aboutText = [
  {
    text: 'Dana Shimal for Lighting General Trading Private Limited is a dynamic and trusted name in the lighting industry, dedicated to illuminating spaces with innovation, quality, and style. Established with a vision to redefine lighting solutions, we specialize in sourcing, supplying, and distributing a diverse range of premium lighting products tailored to meet the evolving needs of residential, commercial, and industrial clients. Our commitment to excellence is reflected in our curated selection of energy-efficient, aesthetically pleasing, and technologically advanced lighting systems, sourced from globally renowned manufacturers.',
  },
  {
    text: 'As a customer-centric organization, we pride ourselves on delivering tailored solutions, seamless project execution, and a reliable supply chain to ensure client satisfaction at every stage. Our team of experienced professionals combines technical expertise with a passion for creativity, helping clients transform their spaces into inspiring environments. Sustainability lies at the heart of our operations, as we strive to promote eco-friendly lighting solutions that reduce energy consumption without compromising on design or performance.',
  },
  // {
  //   text: 'At Dana Shimal for Lighting, we believe lighting is more than functionality—it’s an art that shapes ambiance and elevates experiences. Partner with us to brighten your world with cutting-edge lighting solutions that blend innovation, reliability, and elegance.',
  // },
]

const heroSliders = [
  {
    images: 'slideWrapperOne',
    title: 'For Lighting',
    subTitle: '',
    text: 'Dana Shimal',
    button: 'Contact us now',
  },
  {
    images: 'slideWrapperTwo',
    title: 'For Lighting',
    subTitle: '',
    text: 'Dana Shimal',
    button: 'Contact us now',
  },
]

const portfolioItem = [
  { images: portfolio1, title: 'Lighting', subtitle: '' },
  { images: portfolio2, title: 'Lighting', subtitle: '' },
  { images: portfolio3, title: 'Lighting', subtitle: '' },
  { images: portfolio4, title: 'Lighting', subtitle: '' },
  {
    images: portfolio5,
    title: 'Lighting',
    subtitle: '',
  },
]

const HomePageOne = () => {
  return (
    <Fragment>
      <header className="headerArea">
        {/* <HeaderTop className="headerTop" /> */}
        <HeaderBotton className="headerBottomArea" />
      </header>
      <HeroSlider sliders={heroSliders} className="heroSliderArea" />

      <About
        className="aboutArea"
        title="About Us"
        images={about}
        signature={''}
        pragraphs={aboutText}
      />
      <BlogArea
        className="blogArea"
        title="Products"
        subTitle="From Our Blog
                "
      />
      {/* <Service className="serviceArea" /> */}
      <TeamMember
        title="Our Products "
        // subTitle="Meet Our Experts"
        className="teamArea"
        slider={true}
      />
      {/* <ServiceArea
        className="ourServiceArea"
        title="How Can We Help You"
        subTitle="Area Of Practice"
        services={services}
      /> */}
      <CounterArea className="counterArea" />
      <Portfolio
        className="portfolioArea"
        title="Our Product Types"
        subTitle="Here Our Best Work"
        portfolioItem={portfolioItem}
      />
      {/* <Testmonial className="testmonialArea" /> */}
      {/* <ContactArea className="contactArea" /> */}

      {/* <NewsLetter className="newsLetterArea" /> */}
      <FooterArea />
    </Fragment>
  )
}
export default HomePageOne
